import React from 'react';
import cn from 'classnames';
import css from './BindControl.scss';

type Props = {
	className?: string;
	checked?: boolean;
	onChange: (checked: boolean) => void;
};

const BindControl: React.FC<Props> = props => {
	return (
		<span className={cn(css.bindControl, props.className)}>
			<input type="checkbox" checked={props.checked} onChange={e => props.onChange(e.target.checked)} />
			<i className={css.icon} />
		</span>
	);
};

export default BindControl;
